/**
 * @ngdoc service
 * @name progressBarService
 * @module portaro.services
 *
 * @required ngProgressLite
 *
 * @description
 * Service provides options to control progress bar at the top of the screen
 */
export default class ProgressBarService {
    public static readonly serviceName = 'progressBarService';

    private pendingRequestsCounter = 0;

    /*@ngInject*/
    constructor(private ngProgressLite: angular.progressLite.INgProgressLite) {
    }

    public incrementPendingRequestsCounter() {
        this.pendingRequestsCounter++;
        if (this.pendingRequestsCounter === 1) {
            this.ngProgressLite.start();
        } else {
            this.ngProgressLite.set(this.ngProgressLite.get());
        }
    }

    public decrementPendingRequestsCounter() {
        this.pendingRequestsCounter--;
        if (this.pendingRequestsCounter === 0) {
            this.ngProgressLite.done();
        } else {
            this.ngProgressLite.inc();
        }
    }
}
